import { Component, OnInit, Injectable } from '@angular/core';

@Injectable()
export class LoginToken {
    static UserId: string;
    static UserPassword: string;
    static coreAccessToken: string;
    static clinicAccessToken: string;
    static billingAcessToken: string;
    static TokenType: string;
    static issued: Date;
    static expired: Date;
}
@Injectable()
export class Masterdata {
    static SSalt: string = '4BD85352-A7AE-45BC-B7C2-CE29910ECB05';
}